var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDistributedNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(-11746.666 -3294)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 60,
    height: 60,
    transform: "translate(11746.666 3294)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M11754.941,3319.654v8.694a.96.96,0,0,0,1.92,0v-8.694a.96.96,0,0,0-1.92,0Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M11770.522,3343.346l-7.514-4.343a.961.961,0,0,0-.961,1.663l7.513,4.343a.961.961,0,0,0,.962-1.663Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M11763.009,3309l7.514-4.343a.961.961,0,0,0-.962-1.662l-7.513,4.342a.961.961,0,0,0,.961,1.663Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M11798.392,3328.348v-8.694a.932.932,0,0,0-.934-.933h-.054a.931.931,0,0,0-.933.933v8.694a.96.96,0,0,0,1.92,0Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M11779.657,3307.1l2.269,3.935h-18.37a.96.96,0,0,0,0,1.92h19.478l2.7,4.69-19.1,11.042-6.078-10.54a.96.96,0,0,0-1.663.959l6.079,10.542-2.926,1.691a.961.961,0,0,0,.962,1.663l2.923-1.69,2.15,3.729h-4.525a.96.96,0,0,0,0,1.92h5.634l2.821,4.9a.961.961,0,0,0,1.664-.96l-2.269-3.935h18.37a.96.96,0,0,0,0-1.92H11770.3l-2.7-4.69,19.1-11.042,6.078,10.54a.961.961,0,0,0,1.664-.959l-6.08-10.542,2.926-1.691a.961.961,0,0,0-.961-1.663l-2.924,1.69-2.15-3.729h4.525a.96.96,0,0,0,0-1.92h-5.635l-2.821-4.9a.961.961,0,0,0-1.664.96Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M11790.324,3339l-7.514,4.343a.961.961,0,0,0,.962,1.662l7.513-4.342a.961.961,0,0,0-.961-1.663Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M11758.3,3307.839a4.8,4.8,0,1,0,2.237,2.915A4.8,4.8,0,0,0,11758.3,3307.839Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M11799.832,3331.846a4.8,4.8,0,1,0,2.237,2.915A4.8,4.8,0,0,0,11799.832,3331.846Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M11799.832,3316.154a4.8,4.8,0,1,0-6.557-1.757,4.8,4.8,0,0,0,6.557,1.757Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M11757.143,3331.366a4.8,4.8,0,1,0,2.915,2.237A4.8,4.8,0,0,0,11757.143,3331.366Z",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.801,
    cy: 4.801,
    r: 4.801,
    transform: "translate(11771.865 3295.192)",
    fill: "#18c99d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 4.801,
    cy: 4.801,
    r: 4.801,
    transform: "translate(11771.865 3343.205)",
    fill: "#18c99d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistributedNode);
export default __webpack_public_path__ + "static/media/icon-distributed-node.b74e33226f4b4109d0a12691a94f4387.svg";
export { ForwardRef as ReactComponent };